// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ced9cee","732":"dafea64e","977":"f2d6e8f0"}[chunkId] + ".chunk.js";
};